<template>
  <div>

    <h5 class="info-text">Company</h5>

    <div class="row justify-content-center">

      <div class="col-md-6 col-sm-12">
        <fg-input name="vat"
                  placeholder="VAT (required)"
                  v-model="model.vat"
                  v-validate="modelValidations.vat"
                  :error="getError('vat')"
                  addon-left-icon="nc-icon nc-single-02">
        </fg-input>

      </div>
      <div class="col-md-3 col-sm-12">
        <p-button type="info" style="margin: auto;" v-on:click="validateVAT() ">Auto fill from VIES</p-button>
      </div>
      <div class="col-md-3 col-sm-12">
        <p-button type="info" style="margin: auto;margin-left: 20px;" v-on:click="validateVATFromDB() ">Auto fill from database</p-button>
      </div>


      <div class="col-md-12 col-sm-12">
        <fg-input name="company_name"
                  placeholder="Company name (required)"
                  v-model="model.company_name"
                  v-validate="modelValidations.company"
                  :error="getError('company_name')"
                  addon-left-icon="nc-icon nc-circle-10">
        </fg-input>
      </div>
      <div class="col-md-12 col-sm-12">
        <fg-input name="legal form"
                  placeholder="legal form (required)"
                  v-model="model.legal_form"
                  v-validate="modelValidations.legal_form"
                  :error="getError('legal_form')"
                  addon-left-icon="nc-icon nc-circle-10">
        </fg-input>
      </div>
      <div class="col-md-12 col-sm-12">
         <fg-input>
              <el-select class="select-primary"
                         size="large"
                         placeholder="Language"
                         v-validate="modelValidations.language"
                         :error="getError('language')"
                         v-model="model.language">
                <el-option v-for="option in languages"
                           class="select-primary"
                           :value="option"
                           :label="option"
                           :key="option">
                </el-option>
              </el-select>
            </fg-input>
      </div>
      <div class="col-md-12 col-sm-12">
        <fg-input name="email"
                  placeholder="Email (required)"
                  v-model="model.contact.email"
                  v-validate="modelValidations.email"
                  :error="getError('email')"
                  addon-left-icon="nc-icon nc-send">
        </fg-input>
      </div>
      <div class="col-md-12 col-sm-12">
        <fg-input name="phone"
                  placeholder="Phone (required)"
                  v-model="model.contact.phone_number"
                  v-validate="modelValidations.phone"
                  :error="getError('phone')"
                  addon-left-icon="nc-icon nc-mobile">
        </fg-input>
      </div>


            <div class="col-md-12 col-sm-12">
        <fg-input name="companystreet"
                  placeholder="Street name (required)"
                  v-model="model.companyAddress.street"
                  v-validate="modelValidations.company_street"
                  :error="getError('companystreet')"
                  addon-left-icon="nc-icon nc-shop">
        </fg-input>
      </div>
      <div class="col-md-12 col-sm-12">
        <fg-input name="companystreetnumber"
                  placeholder="Street number (required)"
                  v-model="model.companyAddress.street_number"
                  v-validate="modelValidations.street_number"
                  :error="getError('companystreetnumber')"
                  addon-left-icon="nc-icon nc-shop">
        </fg-input>
      </div>
      <div class="col-md-12 col-sm-12">
        <fg-input name="companyboxnumber"
                  placeholder="Box number"
                  v-model="model.companyAddress.box_number"
                  addon-left-icon="nc-icon nc-shop">
        </fg-input>
      </div>
      <div class="col-md-12 col-sm-6">
        <fg-input name="companypostal_code"
                  placeholder="Post code (required)"
                  v-model="model.companyAddress.postal_code"
                  v-validate="modelValidations.company_post_code"
                  :error="getError('companypostal_code')"
                  addon-left-icon="nc-icon nc-shop">
        </fg-input>
      </div>
      <div class="col-md-12  col-sm-6">
        <fg-input name="companylocality"
                  placeholder="Locality (required)"
                  v-model="model.companyAddress.locality"
                  v-validate="modelValidations.company_locality"
                  :error="getError('companylocality')"
                  addon-left-icon="nc-icon nc-shop">
        </fg-input>
      </div>


    </div>

    <br><br>
    <h5 class="info-text">Point of sale</h5>

    <div class="row justify-content-center">


      <div class="col-md-12 col-sm-12">
        <div class="col-md-12 col-sm-12">
          <fg-input name="Point of sale name"
                    placeholder="Point of sale name (required)"
                    v-model="model.installationAddress.name"
                    addon-left-icon="nc-icon nc-circle-10">
          </fg-input>
        </div>
        <fg-input>
          <el-select class="select-primary"
                     size="large"
                     placeholder="Gender"
                     v-model="model.contact.gender">
            <el-option v-for="option in gender"
                       class="select-primary"
                       :value="option"
                       :label="option"
                       :key="option">
            </el-option>
          </el-select>
        </fg-input>
      </div>
      <div class="col-md-12 col-sm-12">
        <fg-input name="First name"
                  placeholder="First name (required)"
                  v-model="model.contact.first_name"
                  v-validate="modelValidations.firstName"
                  :error="getError('First name')"
                  addon-left-icon="nc-icon nc-circle-10">
        </fg-input>
      </div>
      <div class="col-md-12 col-sm-12">
        <fg-input name="last name"
                  placeholder="Last name (required)"
                  v-model="model.contact.last_name"
                  v-validate="modelValidations.lastName"
                  :error="getError('last name')"
                  addon-left-icon="nc-icon nc-circle-10">
        </fg-input>
      </div>
      <div class="col-md-12 col-sm-12">
        <fg-input name="function"
                  placeholder="Function (required)"
                  v-model="model.contact.title"
                  v-validate="modelValidations.title"
                  :error="getError('function')"
                  addon-left-icon="nc-icon nc-circle-10">
        </fg-input>
      </div>
      <div class="col-md-12 col-sm-12">
        <fg-input name="activity"
                  placeholder="Activity (required)"
                  v-model="model.activity"
                  v-validate="modelValidations.activity"
                  :error="getError('activity')"
                  addon-left-icon="nc-icon nc-circle-10">
        </fg-input>
      </div>

            <div class="col-md-12 col-sm-12">
        <fg-input name="installationstreet"
                  placeholder="Street name (required)"
                  v-model="model.installationAddress.street"
                  v-validate="modelValidations.installation_street"
                  :error="getError('installationstreet')"
                  addon-left-icon="nc-icon nc-shop">
        </fg-input>
      </div>
      <div class="col-md-12 col-sm-12">
        <fg-input name="installationstreetnumber"
                  placeholder="Street number (required)"
                  v-model="model.installationAddress.street_number"
                  v-validate="modelValidations.installation_street_number"
                  :error="getError('installationstreetnumber')"
                  addon-left-icon="nc-icon nc-shop">
        </fg-input>
      </div>
      <div class="col-md-12 col-sm-12">
        <fg-input name="installationboxnumber"
                  placeholder="Box number"
                  v-model="model.installationAddress.box_number"
                  addon-left-icon="nc-icon nc-shop">
        </fg-input>
      </div>
      <div class="col-md-12 col-sm-6">
        <fg-input name="installationpostal_code"
                  placeholder="Post code (required)"
                  v-model="model.installationAddress.postal_code"
                  v-validate="modelValidations.installation_post_code"
                  :error="getError('installationpostal_code')"
                  addon-left-icon="nc-icon nc-shop">
        </fg-input>
      </div>
      <div class="col-md-12  col-sm-6">
        <fg-input name="installationlocality"
                  placeholder="Locality (required)"
                  v-model="model.installationAddress.locality"
                  v-validate="modelValidations.installation_locality"
                  :error="getError('installationlocality')"
                  addon-left-icon="nc-icon nc-shop">
        </fg-input>
      </div>

      <div class="col-sm-12 col-md-13">
                <fg-input>
                  <el-select multiple class="select-primary"

                             size="large"
                             v-model="model.calendar"
                             placeholder="Working day">
                    <el-option v-for="option in workingDays"

                               class="select-primary"
                               :value="option"
                               :label="option"
                               :key="option">
                    </el-option>
                  </el-select>
                </fg-input>
     </div>
     <div class="col-md-2 col-sm-12">
            <div class="form-group">
              <el-time-select
                v-model="model.from_am"
                :picker-options="{
                  start: '00:00',
                  step: '00:15',
                  end: '23:59'
                }"
                placeholder="From">
              </el-time-select>
            </div>
     </div>
     <div class="col-md-2 col-sm-12">
            <div class="form-group">
              <el-time-select
                v-model="model.to_am"
                :picker-options="{
                  start: '00:00',
                  step: '00:15',
                  end: '23:59'
                }"
                placeholder="To">
              </el-time-select>
            </div>
     </div>
     <span style="text-align:center;"><h4 style="margin-top: 05px;">-</h4></span>
         <div class="col-md-2 col-sm-12">
            <div class="form-group">
              <el-time-select
                v-model="model.from_pm"
                :picker-options="{
                  start: '00:00',
                  step: '00:15',
                  end: '23:59'
                }"
                placeholder="From">
              </el-time-select>
            </div>
     </div>
     <div class="col-md-2 col-sm-12">
            <div class="form-group">
              <el-time-select
                v-model="model.to_pm"
                :picker-options="{
                  start: '00:00',
                  step: '00:15',
                  end: '23:59'
                }"
                placeholder="To">
              </el-time-select>
            </div>
     </div>



    </div>

    <br><br>
    <h5 class="info-text">Payment</h5>

    <div class="row justify-content-center">

      <div class="col-md-12 col-sm-12">
        <fg-input name="beneficiary"
                  placeholder="Beneficiary (required)"
                  v-model="model.payment.beneficiary"
                  v-validate="modelValidations.beneficiary"
                  :error="getError('beneficiary')"
                  addon-left-icon="nc-icon nc-bank">
        </fg-input>
      </div>
      <div class="col-md-12 col-sm-12">
        <fg-input name="iban"
                  placeholder="IBAN (required)"
                  v-model="model.payment.iban"
                  v-validate="modelValidations.iban"
                  :error="getError('iban')"
                  addon-left-icon="nc-icon nc-bank">
        </fg-input>
      </div>
      <div class="col-md-12 col-sm-12">
        <fg-input name="bic"
                  placeholder="BIC"
                  v-model="model.payment.bic"
                  addon-left-icon="nc-icon nc-bank">
        </fg-input>
      </div>
      <div class="col-md-12 col-sm-12">
        <fg-input name="bank"
                  placeholder="Bank"
                  v-model="model.payment.bank"
                  addon-left-icon="nc-icon nc-bank">
        </fg-input>
      </div>
    </div>

      <h5 class="info-text">Terminals</h5>
    <div class="row justify-content-center">
      <div class="col-md-3" style="">
            <fg-input>
              <el-select class="select-primary"
                         size="large"
                         placeholder="Terminal supplier"
                         v-model="model.terminal.supplier"
                         @change="terminalType()">
                <el-option v-for="option in terminals"
                           class="select-primary"
                           :value="option._id"
                           :label="option._id"
                           :key="option._id">
                </el-option>
              </el-select>
            </fg-input>
          </div>
      <div class="col-md-3" style="">
        <fg-input>
          <el-select class="select-primary"
                     size="large"
                     placeholder="Terminal type"
                     v-model="model.terminal.type"
                     >
            <el-option v-for="option in terminals_type"
                       class="select-primary"
                       :value="option.type"
                       :label="option.type"
                       :key="option.type">
            </el-option>
          </el-select>
        </fg-input>
      </div>
      <div class="col-md-4" style="">
        <fg-input name="tid"
                  placeholder="TID"
                  v-model="model.terminal.tid"
                 >
        </fg-input>
      </div>
      <div class="col-md-2">
        <button class="btn btn-success btn-fill" v-on:click="addTerminal" style="margin: auto;">
          Add
        </button>

      </div>

      <div class="col-md-12">
        <el-tag
                :key="tag"
                v-for="tag in model.terminals"
                type="primary"
                :closable="true"
                :close-transition="false"
                @close="handleClose(tag)"
        >
          supplier : {{tag.supplier}} -
          type : {{tag.type}} -
          tid : {{ tag.tid }}
        </el-tag>

      </div>

      <!--
        <div class="col-md-12" style="">
          <el-tag
              :key="tag"
              v-for="tag in model.terminal.tid"
              type="primary"
              :closable="true"
              :close-transition="false"
              @close="handleClose(tag)"
            >
              {{tag}}
            </el-tag>

            <input type="text" placeholder="Add tid's here" class="form-control input-new-tag"
                   v-model="tags.inputValue"
                   ref="saveTagInput"
                   size="mini"
                   @keyup.enter="handleInputConfirm"
                   @blur="handleInputConfirm"/>

      </div>
      -->

    </div>
  </div>
</template>
<script>
  import {Upload,TimeSelect, Select, Tag, Option} from 'element-ui';

  export default {
    components: {
      [Upload.name]: Upload,
      [Option.name]: Option,
      [Select.name]: Select,
      [TimeSelect.name]: TimeSelect,
      [Tag.name]: Tag,
    },
    data() {
      return {
        languages: ['fr', 'nl'],
        tags: {
          inputVisible: false,
          inputValue: ''
        },
        terminals: [],
        terminals_type: [],
        timeFrom: '',
        timeTo: '',
        timeFrom2: '',
        timeTo2: '',
        gender: ['M', 'F', 'X'],
        workingDays: ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'],
        vatInfo : {},
        model: {
          from_am : '09:00',
          to_am: '13:00',
          from_pm: '14:00',
          to_pm: '18:00',
          vat: '', // TEST BE0548732067
          activity: '',
          company_name: '',
          legal_form: '',
          language: 'nl',
          calendar: ["monday","tuesday","wednesday","thursday","friday"],
          companyAddress: {
            street: '',
            street_number: '',
            postal_code: '',
            box_number: '',
            locality: '',
          },
          installationAddress: {
            name: '',
            street: '',
            street_number: '',
            postal_code: '',
            box_number: '',
            locality: '',
          },
          contact: {
            email: '',
            first_name: '',
            last_name: '',
            phone_number: '',
            title: '',
            gender: 'M'
          },
          payment: {
            bank: '',
            iban: '',
            bic: '',
            beneficiary: ''
          },
          terminals: [],
          terminal: {
            supplier: '',
            type: '',
            tid: ''
          }
        },
        modelValidations: {
          legal_form: {
            required: true
          },
          bank: {
            required: true,
          },
          language: {
            required: true,
          },
          iban: {
            required: true,
          },
          beneficiary: {
            required: true,
          },
          installation_street: {
            required: true,
            min: 2
          },
          installation_street_number: {
            required: true,
            min: 1
          },
          installation_locality: {
            required: true,
            min: 2
          },
          installation_post_code: {
            required: true,
            min: 2
          },
          company_street: {
            required: true,
            min: 2
          },
          company_street_number: {
            required: true,
            min: 1
          },
          company_locality: {
            required: true,
            min: 2
          },
          company_post_code: {
            required: true,
            min: 2
          },
          company: {
            required: true,
            min: 2
          },
          vat: {
            required: true,
            min: 10
          },
          firstName: {
            required: true,
            min: 2
          },
          lastName: {
            required: true,
            min: 5
          },
          title: {
            required: true
          },
          activity: {
            min: 2,
            required: true
          },
          email: {
            required: true,
            email: true
          },
          phone: {
            required: true
          },
          street_number: {
            required: true,
            min: 1
          }
        }
      }
    },
    mounted() {
      this.getTerminals()
      //console.log(this.model)
    },
    methods: {
      terminalType() {
        this.model.terminal.type = '';
        this.terminals.forEach(el => {
          if(el._id === this.model.terminal.supplier) {
            this.terminals_type = el.types
          }
        })
      },
      addTerminal() {
        this.model.terminals.push(JSON.parse(JSON.stringify(this.model.terminal)))
        /*
        this.terminals.forEach(sub => {
          if(sub._id === this.model.type) {
            this.model.terminals.push({
              type: sub.type,
              supplier: sub.supplier,
              tid: this.model.terminal.tid
            })
          }
        })
        */
      },
      getError(fieldName) {
        return this.errors.first(fieldName)
      },
      validate() {
        return this.$validator.validateAll().then(res => {
          this.$emit('on-validated', res, this.model)
          return res
        })
      },
      getTerminals() {
        this.$http({
          method: 'get',
          url: this.$apiUrl + '/terminal/terminalBySupplier',
          headers: {'Authorization': 'Bearer ' + localStorage.token}
        }).then(response => (
          console.log(response.data),
          this.terminals = response.data
        )).catch(err => {
          this.$notify({
            message: 'Impossible to retrieve data',
            type: 'danger',
            horizontalAlign: 'center',
            verticalAlign: 'top'
          })
        })
      },
      validateVATFromDB() {
        this.$http({
          method: 'get',
          url: this.$apiUrl + '/validity/vatFromDB',
          headers: {'Authorization': 'Bearer ' + localStorage.token},
          params: {vat : this.model.vat},
        }).then(response => (
          this.splitVATInfoFromDB(response)
        )).catch(err => {
          this.$notify({
            message: 'Impossible to retrieve data',
            type: 'danger',
            horizontalAlign: 'center',
            verticalAlign: 'top'
          })
        })
      },
      validateVAT() {
        this.$http({
          method: 'get',
          url: this.$apiUrl + '/validity/vat',
          headers: {'Authorization': 'Bearer ' + localStorage.token},
          params: {vat : this.model.vat},
        }).then(response => (
          this.splitVATInfo(response.data)
        )).catch(err => {
          this.$notify({
            message: 'Impossible to retrieve data',
            type: 'danger',
            horizontalAlign: 'center',
            verticalAlign: 'top'
          })
        })
      },
      splitVATInfoFromDB(response) {
        if (response.data) {
          if(response.data.calendar) {
            this.model.calendar = [];
            Object.keys(response.data.calendar).forEach(obj => {
              this.model.calendar.push(obj);
            })
          }

          if(response.data.companyAddress) {
              if (response.data.companyAddress.box_number) {
                  if (response.data.companyAddress.box_number === '0' || response.data.companyAddress.box_number === 0) {
                      response.data.companyAddress.box_number = ''
                  }
              }
          }
            if(response.data.installationAddress) {
                if (response.data.installationAddress.box_number) {
                    if (response.data.installationAddress.box_number === '0' || response.data.installationAddress.box_number === 0) {
                        response.data.installationAddress.box_number = ''
                    }
                }
            }
            this.model.companyAddress = response.data.companyAddress,
            this.model.installationAddress = response.data.installationAddress,
            this.model.contact = response.data.contact,
                    this.model.contact.gender = 'M',
            this.model.payment = response.data.payment,
            this.model.company_name = response.data.company_name,
            //this.model.terminal = response.data.terminal,
            this.model.legal_form = response.data.legal_form
            if(typeof(response.data.activities[0]) === 'string') {
              this.model.activity = response.data.activities[0]
            } else {
              this.model.activity = ""
            }


          }
      },
      splitVATInfo(vatInfo) {
        console.log((vatInfo.valid === true) || vatInfo.valid === 'true')
        if (vatInfo.valid && (vatInfo.valid === true || vatInfo.valid === 'true')) {
            this.$notify({
              message: 'VAT number correct',
              type: 'success',
              horizontalAlign: 'center',
              verticalAlign: 'top'
            })
            let tempAddr = vatInfo.address.split(',')
            this.model.companyAddress.street = tempAddr[0].match(/[ a-zA-Z-]+|[0-9/]+/g)[0]
            this.model.companyAddress.street_number = tempAddr[0].match(/[ a-zA-Z-]+|[0-9/]+/g)[1]
            this.model.companyAddress.postal_code = tempAddr[1].match(/[a-zA-Z-]+|[0-9/-]+/g)[0]
            this.model.companyAddress.locality = tempAddr[1].match(/[a-zA-Z-]+|[0-9/-]+/g)[1]
            this.model.installationAddress.street = tempAddr[0].match(/[ a-zA-Z-]+|[0-9/]+/g)[0]
            this.model.installationAddress.street_number = tempAddr[0].match(/[ a-zA-Z-]+|[0-9/]+/g)[1]
            this.model.installationAddress.postal_code = tempAddr[1].match(/[a-zA-Z-]+|[0-9/-]+/g)[0]
            this.model.installationAddress.locality = tempAddr[1].match(/[a-zA-Z-]+|[0-9/-]+/g)[1]
            this.model.company_name = vatInfo.name
          } else {
            this.$notify({
            message: 'Incorrect VAT number',
            type: 'danger',
            horizontalAlign: 'center',
            verticalAlign: 'top'
          }),
            this.model.vat = ''
          }
      },
      handleClose (tag) {
        this.model.terminals.splice(this.model.terminals.indexOf(tag), 1)
      },
      showInput () {
        this.tags.inputVisible = true
        this.$nextTick(() => {
          this.$refs.saveTagInput.$refs.input.focus()
        })
      },

      handleInputConfirm () {
        let inputValue = this.tags.inputValue
        if (inputValue) {
          this.model.terminal.tid.push(inputValue)
        }
        this.tags.inputVisible = false
        this.tags.inputValue = ''
      }
    }
  }
</script>
<style lang="scss">
 .el-tag.el-tag--info {
    color:white;
 }
</style>
